import React, { useEffect, useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../../store/hook";
import { studyActions } from "../../store/study/studySlice";
import * as studySlice from "../../store/study/studySlice";
import { profileActions } from "../../store/profile/profileSlice";
import * as profileSlice from "../../store/profile/profileSlice";

export const useStudy = () => {
  const dispatch = useAppDispatch();

  return {
    setProgress: useCallback(
      (payload) => {
        dispatch(studyActions.setProgress(payload));
      },
      [dispatch],
    ),
    setIRLevelMapping: useCallback(
      (payload) => {
        dispatch(studyActions.setIRLevelMapping(payload));
      },
      [dispatch],
    ),
    updateProfile: useCallback(
      (payload) => {
        dispatch(profileActions.changeProfile(payload));
      },
      [dispatch],
    ),
    assignCourse: useCallback(
      (payload) => {
        dispatch(studyActions.assignCourse(payload));
      },
      [dispatch],
    ),
    setPaused: useCallback(
      (payload) => {
        dispatch(studyActions.setPaused(payload));
      },
      [dispatch],
    ),
    setSynonyms: useCallback(
      (payload) => {
        dispatch(studyActions.setSynonyms(payload));
      },
      [dispatch],
    ),
    loadSynonyms: useCallback(
      (payload) => {
        dispatch(studyActions.loadSynonyms(payload));
      },
      [dispatch],
    ),
    setSynonymsLoading: useCallback(
      (payload) => {
        dispatch(studyActions.setSynonymsLoading(payload));
      },
      [dispatch],
    ),
    setRecapWatchingCompleted: useCallback(
      (payload) => {
        dispatch(studyActions.setRecapCompleted(payload));
      },
      [dispatch],
    ),
    setScores: useCallback(
      (payload) => {
        dispatch(studyActions.updateScores(payload));
      },
      [dispatch],
    ),
    clearScores: useCallback(() => {
      dispatch(studyActions.clearScores());
    }, [dispatch]),
    setAudioPlaying: useCallback(
      (payload) => {
        dispatch(studyActions.setAudioPlaying(payload));
      },
      [dispatch],
    ),
    setFailed: useCallback(
      (payload) => {
        dispatch(studyActions.setFailed(payload));
      },
      [dispatch],
    ),
    setFailedWords: useCallback(
      (payload) => {
        dispatch(studyActions.setFailedWords(payload));
      },
      [dispatch],
    ),
    setSuccessWords: useCallback(
      (payload) => {
        dispatch(studyActions.setSuccessWords(payload));
      },
      [dispatch],
    ),
    setActiveWords: useCallback(
      (payload) => {
        dispatch(studyActions.setActiveWords(payload));
      },
      [dispatch],
    ),
    setActiveSentence: useCallback(
      (payload) => {
        dispatch(studyActions.setActiveSentence(payload));
      },
      [dispatch],
    ),
    setFailedWordsForSentence: useCallback(
      (payload) => {
        dispatch(studyActions.setFailedWordsForSentence(payload));
      },
      [dispatch],
    ),
    setSuccessWordsForSentence: useCallback(
      (payload) => {
        dispatch(studyActions.setSuccessWordsForSentence(payload));
      },
      [dispatch],
    ),
    setMissedWordsForSentence: useCallback(
      (payload) => {
        dispatch(studyActions.setMissedWordsForSentence(payload));
      },
      [dispatch],
    ),
    clearWordsHistory: useCallback(() => {
      dispatch(studyActions.clearWordsHistory());
    }, [dispatch]),

    scores: useAppSelector(studySlice.getScores),
    progress: useAppSelector(studySlice.getProgress),
    irLevelMapping: useAppSelector(studySlice.getIRLevelMapping),
    profile: useAppSelector(profileSlice.getProfile),
    paused: useAppSelector(studySlice.getPaused),
    synonyms: useAppSelector(studySlice.getSynonyms),
    synonymsLoading: useAppSelector(studySlice.synonymsLoading),
    recapCompleted: useAppSelector(studySlice.getRecapCompleted),
    audioPlaying: useAppSelector(studySlice.audioPlaying),
    failed: useAppSelector(studySlice.getFailed),
    failedWords: useAppSelector(studySlice.getFailedWords),
    successWords: useAppSelector(studySlice.getSuccessWords),
    activeWords: useAppSelector(studySlice.getActiveWords),
    activeSentence: useAppSelector(studySlice.getActiveSentence),
    failedWordsHistory: useAppSelector(studySlice.getFailedWordsHistory),
    successWordsHistory: useAppSelector(studySlice.getSuccessWordsHistory),
    missedWordsHistory: useAppSelector(studySlice.getMissedWordsHistory),
  };
};
